"use strict";

require("../../style/index.less");

require("./index.less");
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/tag/style/index.js
// module id = 1163
// module chunks = 0